import { AdSlot } from "react-dfp";

const LeaderboardAdSlot = () => (
  <div id="leaderboard-ad" className="flex justify-center">
    <AdSlot
      slotId="leaderboard-ad"
      sizes={[
        [728, 90],
        [300, 50],
      ]}
      sizeMapping={[
        { viewport: [729, 0], sizes: [[728, 90]] },
        { viewport: [301, 0], sizes: [[300, 50]] },
      ]}
      adUnit="Test_728x90"
    />
  </div>
);

export default LeaderboardAdSlot;
